import { render, staticRenderFns } from "./list.html?vue&type=template&id=2881b59a&scoped=true&external"
import script from "./list.js?vue&type=script&lang=js&external"
export * from "./list.js?vue&type=script&lang=js&external"
import style0 from "./list.scss?vue&type=style&index=0&id=2881b59a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2881b59a",
  null
  
)

export default component.exports